import clsx from "clsx";
import React from "react";
import { UserAvatar } from "@/src/components/UserAvatar";

type Props = { children: React.ReactNode; className?: string; image?: string };

const NikeAccountProfileImageHeader: React.FC<Props> = ({
  children,
  image,
  className,
}) => (
  <div className="flex h-fit flex-row">
    <div className={clsx("flex flex-row", className)}>
      <UserAvatar
        src={image}
        height={200}
        width={200}
        containerClassName="w-fit md:-mb-3"
        className="h-24 w-24 object-contain md:h-40 md:w-40"
      />
      {children}
    </div>
  </div>
);

export default NikeAccountProfileImageHeader;
